import { render } from "./LossItemsReport.vue?vue&type=template&id=d0621d9e"
import script from "./LossItemsReport.vue?vue&type=script&lang=js"
export * from "./LossItemsReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__